import React from "react";
import SbEditable from "storyblok-react";
import Image from "~components/atoms/image/image";
import { BLOK_ARRAY } from "../../../prop_types";
import * as classes from "./blog_full_width.module.scss";

export default function BlogFullWidth({ children, ...rest }) {
  if (children?.length > 0) {
    return (
      <SbEditable content={rest}>
        <div className={classes.blogFullWidth}>
          {children.map((childComponent) => {
            return <Image {...childComponent} />;
          })}
        </div>
      </SbEditable>
    );
  }

  return null;
}

BlogFullWidth.defaultProps = {
  children: null,
};

BlogFullWidth.propTypes = {
  children: BLOK_ARRAY,
};
